import { LoginState } from 'src/types/redux';
import { loginConstant } from '../constant';

export const initState: LoginState = {
  loading: false,
  authenticate: false,
  authenticating: false,
  error: '',
  role: '',
  userData: {},
};

export const authReducer = (state = initState, { type, payload }: any) => {
  switch (type) {
    case loginConstant.LOGIN:
      state = {
        ...state,
        loading: true,
        // authenticate: true,
        // authenticating: true,
        // userData: payload[0],
        // role: payload[1],
        error: '',
      };
      break;
    case loginConstant.LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        authenticate: true,
        authenticating: true,
        userData: payload[0],
        role: payload[1],
        error: '',
      };
      break;
    case loginConstant.LOGIN_FAILURE:
      state = {
        ...state,
        loading: false,
        authenticate: false,
        error: payload,
        userData: {},
      };
      break;
    case 'LOGOUT':
      state = {
        ...initState,
      };
  }
  return state;
};
